import Backbone from 'backbone'
import _ from 'lodash'
import ObjectSelector from 'scoreboard/components/object-selector'
import $ from 'jquery'
import FormView from 'scoreboard/components/form-view'
import i18n from 'scoreboard/components/i18n'
import constants from 'scoreboard/components/constants'
import metadata from 'scoreboard/components/metadata'
import metadataGardeners from 'scoreboard/components/metadata-gardeners'
import ScorecardsGardener from 'scoreboard/scorecards/scorecards-gardener'
import { Transform } from 'stream'
import user from 'scoreboard/components/user'
import config from 'scoreboard/components/config'
import DataType from 'scoreboard/datasets/model/data-type'
const { YES_NO } = DataType
import template from './subscription-form.hbs'
import AlertSubscription from 'scoreboard/alerts/alert-subscription'
import alertMetadata from 'scoreboard/alerts/alert-metadata'

/**
 * @return a ScorecardsGardener that disables nodes that can't be used
 * to create alert subscriptions
 */
const ScorecardSubscriptionGardener = ScorecardsGardener.extend({

	_treeOptions: function() {
		var treeOptions = ScorecardsGardener.prototype._treeOptions.apply(this, arguments)
		const {subscription} = this.options

		var map = new Transform({ objectMode: true })
		map._transform = function(node, enc, next) {
			if (disabledNodeReason(node, subscription.type)) {
				node.className = 'is-disabled'
			}
			this.push(node)
			next()
		}
		treeOptions.stream = treeOptions.stream.pipe(map)
		return treeOptions
	}
})

/**
 * @return a Gardener Object for the given section that disables folders
 */
const createDomainSubscriptionGardener = (section) => {
	const Gardener = metadataGardeners[section]
	return Gardener.extend({
		_treeOptions: function() {
			var treeOptions = Gardener.prototype._treeOptions.apply(this, arguments)
			var map = new Transform({ objectMode: true })
			map._transform = function(node, enc, next) {
				const {type} = node
				if (type === 'folder') {
					node.className = 'is-disabled'
				}
				this.push(node)
				next()
			}
			treeOptions.stream = treeOptions.stream.pipe(map)
			return treeOptions
		}
	})
}

/**
 * If a node should not be able to be selected from the Scorecard Object Gardener
 * this function returns the validation reason.  If undefined, the node is valid
 */
const disabledNodeReason = (objectTreeNode, subscriptionType) => {

	const {type} = objectTreeNode
	const valueChangedAlert = subscriptionType === 'metric-value-changed'

	if (type === 'folder') {
		return i18n.get('alerts.subscription.error.folder')
	}

	// make sure an unscored metric is not chosen
	let scoringType = config.scoringType(objectTreeNode.scoringTypeId)
	let isUnscored =
		_.get(scoringType, 'standardScoringType') == constants.UNSCORED ||
		_.get(scoringType, 'kpiValueType') == constants.UNSCORED_TEXT
	if (subscriptionType === 'score-changed' && isUnscored) {
		return i18n.get('alerts.cannotSelectUnscored')
	}

	// For metric value changed alerts, verify a metric is selected
	if (valueChangedAlert) {
		const {sourceType} = objectTreeNode
		var metric = type === 'metric' || sourceType === 'metric'
		if (!metric) {
			return i18n.get('alerts.mustSelectAMetric')
		}
	}

	if (type === 'docking') {
		return i18n.get('alerts.replication.noDockingNodes')
	}
}

/**
 * ADD/EDIT ALERT SUBSCRIPTIONS
 */
var SubscriptionForm = Backbone.View.extend({

	tagName: 'form',

	className: 'subscription-form',

	events: {
		'click .org .node': 'disableButton',
		'click .object .node': 'test'
	},

	/**
	 * @param {String} options.type type of the alert, e.g. score-changed
	 *
	 * @param {Object} options.subscriptionItem the subscription item being modified,
	 * has organization, domainItem and subscription properties
	 */
	initialize: function(options = {isNew: false}) {
		this.options = options
		this.subscriptionItem = this.options.subscriptionItem || {}
		this.subscription = this.subscriptionItem.subscription || {}

		var AlertSubscriptionFormView = FormView.extend({
			test: this.test.bind(this)
		})

		this.formView = new AlertSubscriptionFormView({
			el: this.el,
			submit: this.submit.bind(this)
		})
		this.initializeObjectSelector()
		this.alertSubscription = new AlertSubscription({
			scorecardItem: this.subscriptionItem.domainItem,
			subscription: this.subscriptionItem.subscription
		})

	},

	/**
	 * Add node tree.
	 * If editing a subscription, apply additional data
	 */
	initializeObjectSelector: function () {
		const subscription = this.subscription
		const {domainType} = subscription
		const section = metadata[domainType].section

		let objectGardener
		if (domainType === 'scorecard-item') {
			objectGardener = ScorecardSubscriptionGardener
		} else {
			objectGardener = createDomainSubscriptionGardener(section)
		}

		this.objectSelector = new ObjectSelector({
			objectGardener,
			projectId: _.result(this.subscriptionItem, 'organization.projectId'),
			orgId: _.result(this.subscriptionItem, 'organization.id'),
			section,
			id: subscription.domainId,
			objectParams: {
				dataType: true,
				currencyCode: true,
				scoringType: true,
				sourceType: true
			},
			showProjectSelector: true,
			subscription
		})
		// #12127 make sure updateDataType is called before formView.change
		this.objectSelector.on('select', node => _.invoke(this.alertSubscription, 'updateDataType', node))
		this.objectSelector.on('select', this.formView.change.bind(this.formView))
	},

	render: function() {
		const {type} = this.subscription
		this.$el.empty().append(template(this.context()))

		// Alert Subscription Fields
		if (type === 'comment-added' || type === alertMetadata.types.CHANGE_PUBLISHED) {
			this.$('.subscription-data').remove()
		} else {
			this.$('.subscription-settings').append(this.alertSubscription.el)
			this.alertSubscription.render()
		}

		this.$('.object-selector-container').append(this.objectSelector.el)
		this.objectSelector.render()

		this.formView.start()

		return this
	},

	context: function() {
		const {type, domainType} = this.subscription
		let domainCode = metadata[domainType].singularCode
		if (domainType === 'scorecard-item') {
			domainCode = 'scorecards.scorecardNode'
		}
		return _.extend({
			headerLabel: i18n.get('common.selectA.withArg', i18n.get(domainCode)),
			buttonLabel: this.options.isNew ? 'common.add' : 'common.save'
		}, alertMetadata.getI18nDialogLabels(type, domainType, this.options.isNew), this.options)
	},

	disableButton: function() {
		this.formView.primaryButton.disable()
	},

	test: function(e) {
		var msg = FormView.prototype.test.apply(this, arguments)
		if (msg) {
			return msg
		}
		const node = this.objectSelector.selected()
		const domainItemSelected = !!node
		const {type, domainType} = this.subscription

		// Make sure a scorecard item is selected
		if (!domainItemSelected) {
			if (type === 'metric-value-changed') {
				return i18n.get('alerts.mustSelectAMetric')
			} else {
				return i18n.get(`common.error.mustSelect.${domainType}`)
			}
		}
		// Make sure the selection is valid
		return disabledNodeReason(node, type)
	},

	submit: function(e) {
		/*
		 * Set up compiled subscription data to be
		 * sent back to email-preferences.js to update
		 * the subscription list
		 */
		var domainItem = this.objectSelector.objectGardener.tree.selected()
		var org = this.objectSelector.orgGardener.tree.selected()

		var subscriptionData = {
			organization: org,
			domainItem,
			subscription: {}
		}

		var data = this.alertSubscription.updateSubscriptionWithFormValues()
		/* Additional data needed that formHelper can't grab */
		this._extendFormData(data, domainItem)

		_.extend(subscriptionData.subscription, data)

		return $.ajax({
			method: data.id ? 'patch' : 'post',
			url: 'api/alerts/subscriptions',
			data: JSON.stringify(data),
			success: id => {
				_.extend(subscriptionData.subscription, {id})
				this.trigger('done', subscriptionData)
			}
		})
	},

	_extendFormData: function (data, domainItem) {
		const subscription = _.get(this.subscriptionItem, 'subscription', {})
		_.extend(data, {
			owningPrincipal: user.principal,
			domainId: domainItem.id ? domainItem.id : subscription.domainId,
			type: this.subscriptionItem ? subscription.type : this.options.type,
			id: this.subscriptionItem ? subscription.id : null,
			// #12026 set comparison for yes/no metrics to 'equal', since it can't be obtained via formHelper
			comparison: _.get(data, 'comparison', domainItem.dataType === YES_NO ? 'equals' : undefined)
		})
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.formView, this.objectSelector, this.alertSubscription], 'remove')
	}

})

export default SubscriptionForm

SubscriptionForm.__filename__ = 'admin/alerts/subscription-form.js'
